//**auto-generated don't edit this code**//
export enum UnassignType {
	PrimaryTeacher,
	Specialist,
	Both,
}